<script>
    import Knob from './Knob.svelte'

    export let value = 0;

    let animateOptions = {
        animated: true,
        animateValue: true,
        animationDuration: '2000',
    };
    let knobText = (val) => val.toString() + '%';    
</script>

<div>
    <Knob
        value="{value}"
        min="{0}"
        max="{100}"
        responsive="{true}"
        valueDisplayFunction="{knobText}"
        primaryColor="#0369a1"
        secondaryColor="#f3f4f6"
        animation="{animateOptions}"
    />
</div>
